function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { cmsActions } from '../../reducers/cms.reducer';
import { modalActions } from '../../reducers/modal.reducer';
import useHasPermission from '../../helpers/hooks/useHasPermission';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import CardBody from '../common/card/CardBody.react';
import Button from '../common/Button.react';
import Input from '../common/form/Input.react';
import Label from '../common/form/Label.react';
var ContactEmails = function ContactEmails(_ref) {
  var contactType = _ref.contactType,
    contactsAction = _ref.contactsAction,
    _ref$emails = _ref.emails,
    emails = _ref$emails === void 0 ? [] : _ref$emails;
  var _useParams = useParams(),
    id = _useParams.id;
  var hasPermission = useHasPermission('edit-pos-contacts');
  var _useState = useState({
      address: '',
      emailID: null,
      contactID: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  var emailID = form.emailID,
    address = form.address;
  var updateForm = function updateForm(key, value) {
    setForm(_objectSpread(_objectSpread({}, form), {}, _defineProperty({}, key, value)));
  };
  useEffect(function () {
    setForm(_objectSpread(_objectSpread({}, form), {}, {
      contactID: id
    }));
  }, [id]);
  var isValid = function isValid() {
    return address.length > 0;
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Emails"
  }), /*#__PURE__*/React.createElement(CardBody, null, emails === null || emails === void 0 ? void 0 : emails.map(function (x) {
    return /*#__PURE__*/React.createElement("p", {
      onClick: function onClick() {
        if (!hasPermission) return;
        setForm(_objectSpread(_objectSpread({}, form), {}, {
          address: x.address,
          emailID: x._id
        }));
      },
      key: x._id
    }, x.address);
  }), (emailID || contactType !== 'page-item-contact' || emails.length === 0 && contactType === 'page-item-contact') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    label: "Email Address",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: address,
    onChange: function onChange(e) {
      return updateForm('address', e.target.value);
    },
    permission: "edit-pos-contacts"
  }), /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, emailID && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    label: "Close",
    type: "cancel",
    onClick: function onClick() {
      setForm(_objectSpread(_objectSpread({}, form), {}, {
        address: '',
        emailID: null
      }));
    }
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    type: "delete",
    apiID: "delete-email",
    requireConfirmation: true,
    onClick: function onClick() {
      contactsAction({
        formData: {
          contactID: form.contactID,
          emailID: emailID,
          apiID: 'delete-email'
        },
        method: 'delete',
        route: 'email'
      });
      setForm(_objectSpread(_objectSpread({}, form), {}, {
        address: '',
        emailID: null
      }));
    }
  })), /*#__PURE__*/React.createElement(Button, {
    label: emailID ? 'Update' : 'Add',
    disabled: !isValid(),
    permission: "edit-pos-contacts",
    onClick: function onClick() {
      contactsAction({
        formData: form,
        method: emailID ? 'put' : 'post',
        route: 'email'
      });
      setForm(_objectSpread(_objectSpread({}, form), {}, {
        address: '',
        emailID: null
      }));
    }
  })))));
};
var mdtp = {
  addModalAction: modalActions.add,
  contactsAction: cmsActions.contacts
};
export default connect(null, mdtp)(ContactEmails);